var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"rotate(-90 5.33333333 5.33333333)"},[React.createElement("g",{"key":0},[React.createElement("rect",{"width":"10","height":"10","x":"0","y":".333","fill":"none","transform":"rotate(-180 5 5.33333333)","key":0}),React.createElement("path",{"fillRule":"evenodd","d":"M5.94319203 9.10446843l-.94283914.94283649L.2863107 5.33324949 5.00033376.61923968l.94280412.94280677-3.77118392 3.77117332 3.77123807 3.77124866z","key":1})]),React.createElement("rect",{"width":"9.333","height":"1.333","x":"1.333","y":"4.667","key":1})]));
}

Arrow.defaultProps = {"viewBox":"0 0 10.667 10.667"};

module.exports = Arrow;

Arrow.default = Arrow;
